import { render, staticRenderFns } from "./user_level_detail.vue?vue&type=template&id=0fccc676&scoped=true"
import script from "./user_level_detail.vue?vue&type=script&lang=js"
export * from "./user_level_detail.vue?vue&type=script&lang=js"
import style0 from "./user_level_detail.vue?vue&type=style&index=0&id=0fccc676&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fccc676",
  null
  
)

export default component.exports